import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {IActivityChild, ActivityChild} from '@entities/activity/activity.model';
import {ActivityService} from '@entities/activity/activity.service';
import {JhiEventManager} from 'ng-jhipster';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-activity-type-child-dialog',
  templateUrl: './activity-type-child-dialog.component.html',
})
export class ActivityTypeChildDialogComponent implements OnInit {
  activityChild: IActivityChild;
  isSaving: boolean;
  extendTable: any;
  constructor(
    private dialogRef: MatDialogRef<ActivityTypeChildDialogComponent>,
    private activityService: ActivityService,
    private eventManager: JhiEventManager,
    private titleService: Title,
    private translate: TranslateService,
  ) {
    this.activityChild = new ActivityChild();
    this.isSaving = false;
    this.extendTable = [];
  }

  ngOnInit() {
    if (this.activityChild.id !== null) {
      this.titleService.setTitle(
        this.translate.instant('entities.activity.activityTypeChild.edit'),
      );
    } else {
      this.titleService.setTitle(
        this.translate.instant('entities.activity.activityTypeChild.add'),
      );
    }
    this.getExtendTableOption();
  }

  save() {
    this.isSaving = true;
    if (this.activityChild.id !== null) {
      this.activityService.updateActivityChild(this.activityChild).subscribe(
        (response) => this.onSaveSuccess(response),
        () => this.onSaveError(),
      );
    } else {
      this.activityService.createActivityChild(this.activityChild).subscribe(
        (response) => this.onSaveSuccess(response),
        () => this.onSaveError(),
      );
    }
  }
  getExtendTableOption() {
    this.activityService.getExtendTableOption(1).subscribe((response) => {
      this.extendTable = response.body;
    });
  }
  private onSaveSuccess(result: any) {
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'activityChildListModification',
      content: 'activityType',
    });
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }
}

@Component({
  selector: 'app-activity-child-popup',
  template: '',
})
export class ActivityTypeChildPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<ActivityTypeChildDialogComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({activityId, activityChild}) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(ActivityTypeChildDialogComponent, {
          disableClose: true,
          width: '380px',
        });
        this.dialogRef.componentInstance.activityChild = activityChild;
        this.dialogRef.componentInstance.activityChild.activityTypeId = activityId;

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('entities.activity.activityType.detail'),
    );
    this.dialogRef = null;
  }
}
